import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { theme } from '@garnish/constants';
import { BodyText, VStack } from '@garnish/core';

import { ReceiptLineItemCard } from './components/ReceiptLineItemCard';
import { type PartialLineItem } from './graphql/partials';

// ────────────────────────────────────────────────────────────────────────────────

export const ReceiptLineItems = (props: ReceiptLineItemsProps) => {
  const { lineItems } = props;

  return (
    <VStack gap={0}>
      <BodyText sizeMatch={['16']} bold>
        <FormattedMessage {...messages.yourOrder} />
      </BodyText>

      <VStack gap={0} hasDivider={true} dividerColor={theme.colors.LIGHT}>
        {lineItems.map((lineItem) => (
          <ReceiptLineItemCard key={lineItem.id ?? lineItem.product.name} lineItem={lineItem} />
        ))}
      </VStack>
    </VStack>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  yourOrder: {
    defaultMessage: 'Your order',
    description: 'Order Status | Line Items | Your order heading',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

export type ReceiptLineItemsProps = {
  lineItems: readonly PartialLineItem[];
};
